//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { massiveSelectRequestsMixin } from '@/apps/data-platform/mixins/massive_select_requests';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import { textsDefaul, ACCESS_TYPE_FLOW } from '@/js/constants';
import utils from '@/js/utils';
import FormChangeMetaDataReport from '@/modules/tasks/powerbi/components/report/FormChangeMetaDataReport';
import FormAccessRequestReport from '@/modules/tasks/powerbi/components/report/FormAccessRequestReport';
import DialogsComponent from '@/components/DialogsComponent.vue';
import StateComponent from '@/components/StateComponent.vue';
export default {
  name: 'ListReportAccessRequested',
  mixins: [massiveSelectRequestsMixin],
  components: {
    FormAccessRequestReport: FormAccessRequestReport,
    FormChangeMetaDataReport: FormChangeMetaDataReport,
    DialogsComponent: DialogsComponent,
    StateComponent: StateComponent
  },
  props: {
    typeFlow: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: function data() {
    return {
      MODAL_REPORT_CHANGE_METADATA: 'MODAL_REPORT_CHANGE_METADATA',
      MODAL_REPORT_ACCESS_REQUEST: 'MODAL_REPORT_ACCESS_REQUEST',
      messageEmptyListDs: textsDefaul.LOADING,
      lst_report: [],
      titleModal: 'View Metadata Change (Validation)',
      item: Object,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      currentModal: '',
      filter: '',
      key_modal_meta: 1,
      key_modal_access: 1
    };
  },
  computed: {
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    fieldsDs: function fieldsDs() {
      return [{
        text: this.traductor('my_pendings.tablas.report'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.request_date'),
        value: 'created_datetime',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'center'
      }];
    }
  },
  created: function created() {
    this.reloadReport();
  },
  methods: {
    onSearch: function onSearch(text) {
      this.filter = text;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    reloadReport: function reloadReport() {
      var _this = this;
      var email = window.userInfo.email;
      var typeFlow = this.typeFlow;
      var domain = window.userInfo.domain;
      this.lst_report = [];
      BiReportService.reportPendingApproval({
        typeFlow: typeFlow,
        email: email,
        domain: domain
      }).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this.lst_report = response.data.items;
          } else {
            _this.lst_report = [];
            _this.messageEmptyListDs = textsDefaul.NOT_FOUND;
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onOwnerDs: function onOwnerDs(item) {
      var modalName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.item = item;
      this.key_modal_access += 1;
      this.key_modal_meta += 1;
      if (item.type === ACCESS_TYPE_FLOW.ACCESS) {
        var modal = modalName || this.MODAL_REPORT_ACCESS_REQUEST;
        this.currentModal = modal;
      } else if (item.type === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
        this.currentModal = this.MODAL_REPORT_CHANGE_METADATA;
      }
      this.$refs[this.currentModal].onOpen();
    },
    onCloseModalDs: function onCloseModalDs(reload) {
      //this.$bvModal.hide(this.currentModal)
      this.$refs[this.currentModal].onClose();
      if (reload) {
        this.reloadReport();
      }
    }
  }
};